import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface VendorInformationStateInterface {
  minimumBasket: number;
}

const initialState: VendorInformationStateInterface = {
  minimumBasket: 0,
};

const vendorInformationSlice = createSlice({
  name: 'vendorInformation',
  initialState,
  reducers: {
    init: (state, action: PayloadAction<VendorInformationStateInterface>) => ({
      ...initialState,
      minimumBasket: action.payload.minimumBasket,
    }),
  },
});

export default vendorInformationSlice;
